/**
 * Brand tokens exported as plain TS — for use where CSS vars aren't accessible
 * (motion values, canvas/svg fills, dynamic shadow strings).
 *
 * Keep this in sync with the @theme block in src/styles/globals.css.
 */

export const brand = {
  teal: '#2EAA8A',
  tealDark: '#28967A',
  tealGlow: 'rgba(46,170,138,0.35)',
  saffron: '#E8A857',
  chinar: '#C45A2A',
  cobalt: '#1E3A8A',
  warn: '#FBBF24',
  err: '#F87171',
  ok: '#34D399',
  ice: '#7EC8E3',
} as const;

export type BrandColor = keyof typeof brand;

/** Region accents used on the Kashmir map and seasonal storytelling. */
export const regionAccent = {
  srinagar: brand.teal,
  gulmarg: brand.ice,
  pahalgam: brand.ok,
  sonamarg: brand.saffron,
  doodhpathri: brand.warn,
  gurez: brand.chinar,
} as const;
